import React from 'react';
import { Rocket, Target, Telescope } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="section-padding relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="section-title mx-auto mt-0">About Us</h1>
            <p className="text-lg md:text-xl text-neutral/90 mt-8">
              At QuantumSphere, we are a forward-thinking advisory firm specializing in blockchain innovation, multi-sector technology, and strategic growth—your trusted partner in navigating the future.
            </p>
          </div>

          <div className="space-y-12">
            {/* Vision and Mission Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
              {/* Vision Box */}
              <div className="relative p-6 h-full group">
                <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-accent/5 via-accent/30 to-accent/5 group-hover:via-accent transition-all duration-300 rounded-full"></div>
                <div className="absolute -left-1 top-0 w-3 h-3 rounded-full bg-gradient-to-br from-accent to-accent/50 shadow-lg shadow-accent/20 group-hover:scale-110 transition-transform duration-300"></div>
                <div className="flex flex-col items-center text-center">
                  <Telescope size={40} className="text-accent mb-4 group-hover:scale-110 transition-transform duration-300" />
                  <h4 className="text-xl font-semibold mb-3 text-neutral group-hover:text-accent transition-colors duration-300">Vision</h4>
                  <p className="text-neutral/80">
                    To empower visionary organizations to redefine industries, break boundaries, and achieve unparalleled success in an ever-evolving global landscape.
                  </p>
                </div>
              </div>

              {/* Mission Box */}
              <div className="relative p-6 h-full group">
                <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-accent/5 via-accent/30 to-accent/5 group-hover:via-accent transition-all duration-300 rounded-full"></div>
                <div className="absolute -left-1 top-0 w-3 h-3 rounded-full bg-gradient-to-br from-accent to-accent/50 shadow-lg shadow-accent/20 group-hover:scale-110 transition-transform duration-300"></div>
                <div className="flex flex-col items-center text-center">
                  <Rocket size={40} className="text-accent mb-4 group-hover:scale-110 transition-transform duration-300" />
                  <h4 className="text-xl font-semibold mb-3 text-neutral group-hover:text-accent transition-colors duration-300">Mission</h4>
                  <p className="text-neutral/80">
                    We deliver bold, actionable strategies that transform challenges into opportunities, guiding high-potential startups, scale-ups, and global enterprises toward sustainable growth and market leadership.
                  </p>
                </div>
              </div>
            </div>

            {/* Why Quantumsphere Section */}
            <div className="text-center">
              <h2 className="section-title mx-auto">Why QuantumSphere?</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                <div className="relative p-6 h-full group">
                  <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-accent/5 via-accent/30 to-accent/5 group-hover:via-accent transition-all duration-300 rounded-full"></div>
                  <div className="absolute -left-1 top-0 w-3 h-3 rounded-full bg-gradient-to-br from-accent to-accent/50 shadow-lg shadow-accent/20 group-hover:scale-110 transition-transform duration-300"></div>
                  <h4 className="text-xl font-semibold mb-3 text-neutral group-hover:text-accent transition-colors duration-300">Innovative Approach</h4>
                  <p className="text-neutral/80">
                    We fuse cutting-edge insights with proven execution to craft strategies that are ahead of the curve yet grounded in reality.
                  </p>
                </div>
                <div className="relative p-6 h-full group">
                  <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-accent/5 via-accent/30 to-accent/5 group-hover:via-accent transition-all duration-300 rounded-full"></div>
                  <div className="absolute -left-1 top-0 w-3 h-3 rounded-full bg-gradient-to-br from-accent to-accent/50 shadow-lg shadow-accent/20 group-hover:scale-110 transition-transform duration-300"></div>
                  <h4 className="text-xl font-semibold mb-3 text-neutral group-hover:text-accent transition-colors duration-300">Client-Centric Focus</h4>
                  <p className="text-neutral/80">
                    Your ambitions drive us—every solution is tailored to your unique goals, market dynamics, and vision.
                  </p>
                </div>
                <div className="relative p-6 h-full group">
                  <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-accent/5 via-accent/30 to-accent/5 group-hover:via-accent transition-all duration-300 rounded-full"></div>
                  <div className="absolute -left-1 top-0 w-3 h-3 rounded-full bg-gradient-to-br from-accent to-accent/50 shadow-lg shadow-accent/20 group-hover:scale-110 transition-transform duration-300"></div>
                  <h4 className="text-xl font-semibold mb-3 text-neutral group-hover:text-accent transition-colors duration-300">Measurable Impact</h4>
                  <p className="text-neutral/80">
                    We don't just advise; we deliver results you can see, track, and build upon for lasting success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;